import ApiService from './ApiService'
import axios from 'axios'
export async function apiSignIn(data) {
    return ApiService.fetchData({
        url: '/sign-in',
        method: 'post',
        data,
    })
}

export async function apiSignUp(data) {
    try {
        let jsonData = { ...data };


        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/user/createCompanyAndLogin`, 
            jsonData,
            {
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        )

        return response.data
    } catch (error) {
        console.error('API Error:', error.response?.data);
        throw error
    }
}


export async function apiSignOut(data) {
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data,
    })
}

export async function apiForgotPassword(data) {
    return ApiService.fetchData({
        url: '/forgot-password',
        method: 'post',
        data,
    })
}

export async function apiResetPassword(data) {
    return ApiService.fetchData({
        url: '/reset-password',
        method: 'post',
        data,
    })
}

export async function apiSendSignupEmail(data) {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/user/testEmail`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        )
        return response.data
    } catch (error) {
        console.error('Email API Error:', error.response?.data)
        throw error
    }
}
